export const DrawerToggleRightIcon = ({
  fill = 'currentColor',
  width = '24',
  height = '24',
  viewBox = '0 0 24 24',
  ...rest
}: React.SVGProps<SVGSVGElement>) => (
  <svg width={width} height={height} viewBox={viewBox} fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path
      // eslint-disable-next-line max-len
      d="M3.50024 5.00049C3.50024 4.17206 4.17182 3.50049 5.00024 3.50049H18.9998C19.8282 3.50049 20.4998 4.17206 20.4998 5.00049V19C20.4998 19.8284 19.8282 20.5 18.9998 20.5H5.00024C4.17182 20.5 3.50024 19.8284 3.50024 19V5.00049ZM2.49976 19C2.49976 20.3807 3.61953 21.5005 5.00024 21.5005H18.9998C20.3805 21.5005 21.5002 20.3807 21.5002 19V5.00049C21.5002 3.61978 20.3805 2.5 18.9998 2.5H5.00024C3.61953 2.5 2.49976 3.61978 2.49976 5.00049V19Z"
      fill={fill}
    />
    <path
      // eslint-disable-next-line max-len
      d="M15.5002 21.0002V3.00024C15.5002 2.7241 15.2761 2.5 15 2.5C14.7239 2.5 14.4998 2.7241 14.4998 3.00024V21.0002C14.4998 21.2764 14.7239 21.5005 15 21.5005C15.2761 21.5005 15.5002 21.2764 15.5002 21.0002Z"
      fill={fill}
    />
    <path
      // eslint-disable-next-line max-len
      d="M8.3538 8.6462C8.15854 8.45094 7.84154 8.45094 7.64628 8.6462C7.45102 8.84146 7.45102 9.15846 7.64628 9.35372L10.2925 12L7.64628 14.6462C7.45102 14.8415 7.45102 15.1585 7.64628 15.3537C7.84154 15.549 8.15854 15.549 8.3538 15.3537L11.3538 12.3537C11.5491 12.1585 11.5491 11.8415 11.3538 11.6462L8.3538 8.6462Z"
      fill={fill}
    />
  </svg>
)
